angular.module('dpw.services').factory('brandService', ['$q', 'api', 'rcBrandIds', function ($q, api, rcBrandIds) {
        var brands = null;
        var brandMap = {};
        var fetchBrandsPromise = null;
        return {
            fetchBrands: function () {
                if (fetchBrandsPromise == null) {
                    fetchBrandsPromise = api.call(api.admin.getBrands(), function (data) {
                        brands = data.brands.sort(function (a, b) {
                            if (a.subBrands || b.subBrands) {
                                return sortBrandWithSubs(a, b);
                            }
                            return sortBrandsWithoutSubs(a, b);
                        });
                        brands.forEach(function (brand) {
                            brandMap[brand.brandId] = brand;
                            (brand.subBrands || []).forEach(function (subBrand) {
                                brandMap[subBrand.brandId] = subBrand;
                            });
                        });
                    });
                }
                return fetchBrandsPromise;
            },
            getBrands: function () {
                return brands || [];
            },
            getBrandMap: function () {
                return brandMap;
            }
        };

        function sortBrandWithSubs(a, b) {
            if (a.subBrands && b.subBrands) {
                var flag = compareSortFlagWithRC(a.brandId, b.brandId);
                return flag === 0 ? a.brandName.localeCompare(b.brandName) : flag;
            }

            if (a.subBrands) {
                return -1;
            }

            if (b.subBrands) {
                return 1;
            }

            return 0;
        }

        function sortBrandsWithoutSubs(a, b) {
            var aIsRCFamily = rcBrandIds.includes(a.brandId);
            var bIsRCFamily = rcBrandIds.includes(b.brandId);

            if (aIsRCFamily && bIsRCFamily) {
                return rcBrandIds.indexOf(a.brandId) < rcBrandIds.indexOf(b.brandId) ? -1 : 1;
            }

            if (aIsRCFamily) {
                return -1;
            }
            if (bIsRCFamily) {
                return 1;
            }
            return a.brandName.localeCompare(b.brandName);
        }

        function compareSortFlagWithRC(brandA, brandB) {
            var rcBrand = '1210';
            if (brandA === rcBrand) {
                return -1;
            }
            if (brandB === rcBrand) {
                return 1;
            }
            return 0;
        }
    }]
);
